import {
  ExportClientDeviceByDayRequest,
  ExportClientDeviceByDayResponse,
  ExportClientDeviceByRangeDayRequest,
  ExportClientDeviceByRangeDayResponse,
  ExportTotalClientDeviceByRangeDayRequest,
  ExportTotalClientDeviceByRangeDayResponse,
  GetAllClientDeviceResponse,
  GetClientDeviceByDayRequest,
  GetClientDeviceByDayResponse,
  GetClientDeviceByRangeDayRequest,
  GetClientDeviceByRangeDayResponse,
  GetClientDeviceRequest,
  GetClientDeviceResponse,
  GetErrorClientDeviceRequest,
  GetErrorClientDeviceResponse,
  GetOneClientDeviceRequest,
  GetOneClientDeviceResponse,
  GetTotalClientDeviceByRangeDayRequest,
  GetTotalClientDeviceByRangeDayResponse,
} from '@/types/apis/clientDevice'

import axios from './axios'

const API_ENDPOINT = '/attendance'

const API_CLIENT_DEVICE_ENDPOINT = '/client-devices'

export const getClientDeviceByDay = (request: GetClientDeviceByDayRequest): Promise<GetClientDeviceByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/client-device-by-date`, { params: request })
}

export const exportClientDeviceByDay = (
  request: ExportClientDeviceByDayRequest
): Promise<ExportClientDeviceByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-client-device-by-date`, { params: request })
}

export const getClientDeviceByRangeDay = (
  request: GetClientDeviceByRangeDayRequest
): Promise<GetClientDeviceByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/client-device-by-range-date`, { params: request })
}

export const exportClientDeviceByRangeDay = (
  request: ExportClientDeviceByRangeDayRequest
): Promise<ExportClientDeviceByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-client-device-by-range-date`, { params: request })
}

export const getTotalClientDeviceByRangeDay = (
  request: GetTotalClientDeviceByRangeDayRequest
): Promise<GetTotalClientDeviceByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/total-client-device-by-range-date`, { params: request })
}

export const exportTotalClientDeviceByRangeDay = (
  request: ExportTotalClientDeviceByRangeDayRequest
): Promise<ExportTotalClientDeviceByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-total-client-device-by-range-date`, { params: request })
}

export const getClientDevices = (request: GetClientDeviceRequest): Promise<GetClientDeviceResponse> => {
  return axios.get(API_CLIENT_DEVICE_ENDPOINT, { params: request })
}

export const getAllClientDevice = (): Promise<GetAllClientDeviceResponse> => {
  return axios.get(`${API_CLIENT_DEVICE_ENDPOINT}/all`)
}

export const getClientDevice = (
  id: number,
  request: GetOneClientDeviceRequest
): Promise<GetOneClientDeviceResponse> => {
  return axios.get(`${API_CLIENT_DEVICE_ENDPOINT}/${id}`, { params: request })
}

export const getErrorClientDevices = (request: GetErrorClientDeviceRequest): Promise<GetErrorClientDeviceResponse> => {
  return axios.get(`${API_CLIENT_DEVICE_ENDPOINT}/errors`, { params: request })
}
